import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MembershipService} from '../../../../../../@shared/services/membership-service';
import {_AQH_MEM_5} from '../../../../../../@shared/models/input.module';

@Component({
  selector: 'app-add-membership-plan',
  standalone: false,
  templateUrl: './add-membership-plan.html',
  styleUrl: './add-membership-plan.css'
})
export class AddMembershipPlan {
  code: string = '';
  name: string = '';
  coverage: string = 'individual';
  billing_cycle: string = 'annual';
  price_cents: number = 0;
  max_children: number | null = null;
  saving: boolean = false;

  constructor(private membershipService: MembershipService,
              private modal: NgbActiveModal) {
  }

  onSave() {
    if (!this.code.trim() || !this.name.trim() || !this.coverage) {
      return;
    }

    this.saving = true;
    const params: _AQH_MEM_5 = {
      code: this.code,
      name: this.name,
      coverage: this.coverage,
      billing_cycle: this.billing_cycle,
      price_cents: this.price_cents * 100, // Convert dollars to cents
      max_children: this.coverage === 'family' ? (this.max_children ?? undefined) : undefined
    };

    this.membershipService.createMembershipPlan(params).subscribe({
      next: () => {
        this.saving = false;
        this.modal.close(true);
      },
      error: () => {
        this.saving = false;
      }
    });
  }

  close() {
    this.modal.close();
  }
}
